export default __webpack_public_path__ + "static/media/competencesImage6.94ac2a99.png";